import ContactForm from "@/components/ContactForm";

const ContactSection = () => {
  return (
    <section id="contact-section" className="py-16 sm:py-20 lg:py-32 bg-muted/50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-1/4 w-48 h-48 sm:w-64 sm:h-64 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-1/4 w-48 h-48 sm:w-64 sm:h-64 bg-primary/5 rounded-full blur-3xl" />
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 sm:mb-12 animate-fade-in">
            {/* Urgency badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-primary/10 border border-primary/20 mb-4 sm:mb-6">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
              </span>
              <span className="text-xs sm:text-sm font-medium text-primary">Limited Availability for Peak Season</span>
            </div>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-2">
              Let's Create Something <span className="text-primary">Unforgettable</span>
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground max-w-xl mx-auto px-4">
              Start with a 2-minute form. Get personalized recommendations within 24 hours. 
              <strong className="text-foreground"> Zero obligation.</strong>
            </p>
          </div>
          
          <ContactForm initialData={undefined} initialFormStep={1} />

          {/* Trust signals below form */}
          <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-6 text-xs sm:text-sm text-muted-foreground">
            <div className="flex items-center justify-center gap-2">
              <span className="text-primary">🔒</span>
              <span>Your info is secure</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <span className="text-primary">⚡</span>
              <span>Response in 24hrs</span>
            </div>
            <div className="flex items-center justify-center gap-2">
              <span className="text-primary">💳</span>
              <span>No payment required</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
